import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=437bf234&scoped=true&"
import script from "./CreateOrder.vue?vue&type=script&lang=js&"
export * from "./CreateOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437bf234",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormEdgeConfig: require('/opt/buildhome/repo/components/form/EdgeConfig.vue').default})
